
import moment from "moment";
import { ArrowRight } from "react-feather";
import { toast } from "react-toastify";
import { useAuthStore } from "../../../store/authStore";
import { getFlightDetails } from "../../../api/flightsAPI";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useFlightStore from "../../../store/flightStore";

const FlightInfoModal = ({ flightId }) => {
    const { token } = useAuthStore((state) => state);
    const { setShowFlightModal } = useFlightStore((state) => state);
    const { isLoading, data: flightDetailsData, refetch } = useQuery(["getFlightDetails", token, flightId], () =>
        getFlightDetails(flightId, token)
    )
    const navigate = useNavigate();
    const [flightData, setFlightData] = useState({});

    useEffect(() => {
        if (flightDetailsData?.data?.data?.length > 0) {
            setFlightData(flightDetailsData?.data?.data[0]);
        }
    }, [flightDetailsData])
    return (
        <>
            <div className="grid place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur-sm inset-0">
                <div id="defaultModal" className="p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                    <div className="relative w-full max-w-xl max-h-fit">
                        <div className="relative bg-white rounded-lg dark:bg-white" onBlur={() => { setShowFlightModal(false) }}>
                            <div className="flex items-start justify-between p-4 rounded-t dark:border-gray-600">

                                <span>
                                    <h3 className="text-3xl font-semibold text-gray-900 dark:text-black capitalize">
                                        Review Details
                                    </h3>
                                </span>
                                <button onClick={() => { setShowFlightModal(false) }} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="defaultModal">
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                            </div>
                            <div className="p-4 pt-1 w-full flex flex-wrap">
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Flight Id</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{flightData?.createdAt}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Drone Name</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{flightData?.droneId?.droneName}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Reason</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{flightData?.flightReason}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Mission Name</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{flightData?.missionId?.missionName}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Start Time</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{moment(flightData?.flightStartTime).format("DD/MM/YYYY hh:mm A")}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">End Time</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{moment(flightData?.flightEndTime).format("DD/MM/YYYY hh:mm A")}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Booked By</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{flightData?.createdBy?.fullName}</h3>
                                    </div>
                                </div>
                                <div className="p-4 w-1/2 pt-0">
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Assign To</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{flightData?.assignTo?.fullName}</h3>
                                    </div>
                                </div>
                                {flightData?.rejectionReason &&
                                    <div className="p-4 w-1/2 pt-0">
                                        <div>
                                            <h3 className="text-sm text-tblu font-semibold">Rejection Reason</h3>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold capitalize">{flightData?.rejectionReason}</h3>
                                        </div>
                                    </div>}
                            </div>
                            <div className="flex items-center justify-between p-6  border-t border-gray-200 rounded-b dark:border-gray-600">
                                <div>
                                    <div className="flex">
                                        <span className={`w-3 mt-2 ${flightData?.approvalStatus == "approved" ? "bg-green-400" : flightData?.approvalStatus == "rejected" ? "bg-red-500" : "bg-orange-400"} mr-1 h-3  rounded-full`} />
                                        <button className="capitalize">
                                            {flightData?.approvalStatus}
                                        </button>
                                    </div>
                                </div>
                                <div className="space-x-2">
                                    {/* {
                                        flightData?.approvalStatus === "approved" ? (
                                            <button
                                                onClick={() => {
                                                    setApprovalStatus("rejected");
                                                }}
                                                className="inline-block text-white rounded-lg bg-red-500 px-4 py-2.5 font-semibold text-md capitalize leading-normal"
                                            >
                                                Reject
                                            </button>
                                        ) : flightData?.approvalStatus === "rejected" ? (
                                            <>
                                                <button
                                                    onClick={() => { setApprovalStatus("approved") }}
                                                    className="inline-block text-white rounded-lg bg-green-600 px-4 py-2.5 font-semibold text-md capitalize leading-normal"
                                                >
                                                    Approve
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button onClick={() => { setApprovalStatus("approved") }} className="inline-block text-white rounded-lg bg-green-600 px-4 py-2.5 font-semibold text-md capitalize leading-normal">Approve</button>
                                                <button onClick={() => { setApprovalStatus("rejected") }} className="inline-block text-white rounded-lg bg-red-500 px-4 py-2.5 font-semibold text-md capitalize leading-normal">Reject</button>
                                            </>
                                        )
                                    } */}

                                    {/* <button data-modal-hide="defaultModal" type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Approve</button>
                                    <button data-modal-hide="defaultModal" type="button" className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-red-500 dark:text-gray-300 dark:border-red-500 dark:hover:text-white dark:hover:bg-red-500 dark:focus:ring-red-500">Reject</button> */}


                                    <button onClick={() => {
                                        navigate(`/dashboard/flight-details/${flightData?._id}`);
                                        setShowFlightModal(false);
                                    }}
                                        type="button"
                                        className="inline-block text-white rounded-lg bg-tblu px-4 py-2.5 text-md font-medium capitalize leading-normal">
                                        <div className="flex items-center">
                                            <span> View </span>
                                            &ensp;
                                            <span><ArrowRight /></span>

                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}

export default FlightInfoModal;